// extracted by mini-css-extract-plugin
module.exports = {"Form":"LoginForm_Form__3P0gA","Container":"LoginForm_Container__3jPkP"};